export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-loop-477dec2823e0aca4e73f4b482df9c376.svg";